export const APP_NAME = "It Depends";
